module.exports = __webpack_public_path__ + "assets/f6b9390bb7e410992b1a005328c76872.png";